module.exports = __webpack_public_path__ + "static/media/placeholder-1.da70f8d7.svg";